import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {

  constructor(
    private httpClient: HttpClient
  ) { }

  async setConfig(): Promise<any> {
    try {
      const config = await this.httpClient
        .get<any>(`./assets/environments/environment.json`)
        .toPromise();
      const keys = Object.keys(environment);
      for (const element of keys) {
        environment[element] = config[element];
      }
      
    } catch (err) {
      console.error(`error while reading env`, err);
    }

    return environment;
  }

}
